"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = require("react");
var _stepByStepFormUnlocker = require("../stepByStepFormUnlocker");
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};
    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        (0, _defineProperty2["default"])(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }
  return target;
}
var getData = function getData(_ref) {
  var data = _ref.data;
  var dataKey = Object.keys(data)[0];
  return data[dataKey];
};
var useApolloFetchUnlocker = function useApolloFetchUnlocker(_ref2) {
  var client = _ref2.client,
    _ref2$callFirstField = _ref2.callFirstField,
    callFirstField = _ref2$callFirstField === void 0 ? true : _ref2$callFirstField,
    initialQueryVariables = _ref2.initialQueryVariables,
    mapping = _ref2.mapping,
    submitUrlStructure = _ref2.submitUrlStructure,
    onSubmitCallback = _ref2.onSubmitCallback,
    history = _ref2.history,
    dropdownFormatter = _ref2.dropdownFormatter;
  var _useStepByStepFormUnl = (0, _stepByStepFormUnlocker.useStepByStepFormUnlocker)({
      mapping: mapping,
      submitUrlStructure: submitUrlStructure,
      onSubmitCallback: onSubmitCallback,
      history: history
    }),
    getNextField = _useStepByStepFormUnl.getNextField,
    getNextFieldKey = _useStepByStepFormUnl.getNextFieldKey,
    getCurrentFieldKey = _useStepByStepFormUnl.getCurrentFieldKey,
    formState = _useStepByStepFormUnl.formState,
    fieldOnChange = _useStepByStepFormUnl.fieldOnChange,
    getFieldState = _useStepByStepFormUnl.getFieldState,
    submitIsDisabled = _useStepByStepFormUnl.submitIsDisabled,
    updateFormState = _useStepByStepFormUnl.updateFormState,
    onSubmit = _useStepByStepFormUnl.onSubmit,
    submitUrl = _useStepByStepFormUnl.submitUrl,
    setDefaultValues = _useStepByStepFormUnl.setDefaultValues;
  var fetchData = function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee(_ref3) {
      var queryTag, variables, fieldIndex, e;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              queryTag = _ref3.queryTag, variables = _ref3.variables, fieldIndex = _ref3.fieldIndex, e = _ref3.e;
              _context.next = 3;
              return client.query({
                query: queryTag,
                variables: variables
              }).then(function (res) {
                var resetState = Object.assign({}, formState);
                Object.keys(resetState).forEach(function (key) {
                  var field = resetState[key];
                  var index = field.index;
                  field.data = index > fieldIndex ? [] : field.data;
                  field.variables = index > fieldIndex ? {} : variables;
                });
                var newState = Object.assign({}, formState);
                Object.keys(newState).forEach(function (key) {
                  var field = newState[key];
                  var index = field.index;
                  if (index === fieldIndex) {
                    field.validator = function () {
                      return true;
                    };
                  }
                  if (index === fieldIndex + 1) {
                    field.data = typeof dropdownFormatter === 'function' ? dropdownFormatter(res) : getData(res);
                    field.variables = variables;
                  }
                });
                fieldOnChange(e, resetState);
                fieldOnChange(e, newState);
              });
            case 3:
              return _context.abrupt("return", _context.sent);
            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function fetchData(_x) {
      return _ref4.apply(this, arguments);
    };
  }();
  var callOnChange = function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee2(e) {
      var _getFieldState, fieldState, currentFieldKey, currentState, el, fieldIndex, isSynthetic, currentFieldVariables, newVariable, nextFieldStateKey, nextFieldState, variables, queryTag;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              _getFieldState = getFieldState(e, null), fieldState = _getFieldState.fieldState, currentFieldKey = _getFieldState.currentFieldKey, currentState = _getFieldState.currentState, el = _getFieldState.el, fieldIndex = _getFieldState.fieldIndex, isSynthetic = _getFieldState.isSynthetic;
              currentFieldVariables = fieldState.variables;
              newVariable = {};
              newVariable[currentFieldKey] = el.value;
              nextFieldStateKey = Object.keys(currentState).filter(function (key) {
                return currentState[key].index === fieldIndex + 1;
              })[0];
              nextFieldState = currentState[nextFieldStateKey];
              variables = Object.assign({}, currentFieldVariables || {}, newVariable);
              delete variables[nextFieldStateKey];
              if (!(nextFieldState && nextFieldState.queryTag)) {
                _context2.next = 16;
                break;
              }
              queryTag = nextFieldState.queryTag;
              if (isSynthetic) {
                e.persist();
              }
              _context2.next = 13;
              return fetchData({
                queryTag: queryTag,
                fieldIndex: fieldIndex,
                variables: variables,
                e: e
              });
            case 13:
              return _context2.abrupt("return", _context2.sent);
            case 16:
              fieldOnChange(e, null);
            case 17:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));
    return function callOnChange(_x2) {
      return _ref5.apply(this, arguments);
    };
  }();
  var makeDefaultCalls = function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee3() {
      var defaultKeys, variableSets, fetchAll, res, newState;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              defaultKeys = Object.keys(formState).sort(function (a, b) {
                return formState[a].index - formState[b].index;
              }).filter(function (key) {
                return formState[key].defaultValue !== 'undefined' && formState[key].queryTag;
              });
              variableSets = {};
              defaultKeys.forEach(function (key, i) {
                for (var j = 0; j < i; j++) {
                  variableSets[key] = _objectSpread(_objectSpread({}, variableSets[key]), {}, (0, _defineProperty2["default"])({}, defaultKeys[j], formState[defaultKeys[j]].defaultValue));
                }
              });
              fetchAll = defaultKeys.map(function (key) {
                return client.query({
                  query: formState[key].queryTag,
                  variables: _objectSpread({}, variableSets[key])
                });
              });
              _context3.next = 6;
              return Promise.all(fetchAll);
            case 6:
              res = _context3.sent;
              newState = Object.assign({}, formState);
              defaultKeys.forEach(function (key, i) {
                var field = newState[key];
                var defaultValue = field.defaultValue;
                if (defaultValue) {
                  field.data = typeof dropdownFormatter === 'function' ? dropdownFormatter(res[i]) : getData(res[i]);
                  field.variables = variableSets[key];
                }
              });
              updateFormState(setDefaultValues(newState));
              _context3.next = 12;
              return loadFirstField();
            case 12:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3);
    }));
    return function makeDefaultCalls() {
      return _ref6.apply(this, arguments);
    };
  }();
  var loadFirstField = function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(_regenerator["default"].mark(function _callee4() {
      var firstFieldKey, firstField, queryTag, res, newState, updatedField, _newState, _updatedField;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              if (!callFirstField) {
                _context4.next = 19;
                break;
              }
              firstFieldKey = getCurrentFieldKey({
                state: formState
              });
              if (!firstFieldKey) {
                _context4.next = 19;
                break;
              }
              firstField = formState[firstFieldKey];
              queryTag = firstField.queryTag;
              _context4.prev = 5;
              _context4.next = 8;
              return client.query({
                query: queryTag,
                variables: typeof initialQueryVariables !== 'undefined' ? initialQueryVariables : {}
              });
            case 8:
              res = _context4.sent;
              newState = Object.assign({}, formState);
              updatedField = newState[firstFieldKey];
              updatedField.data = typeof dropdownFormatter === 'function' ? dropdownFormatter(res) : getData(res);
              updatedField.validator = function () {
                return true;
              };
              updateFormState(newState);
              _context4.next = 19;
              break;
            case 16:
              _context4.prev = 16;
              _context4.t0 = _context4["catch"](5);
              if (_context4.t0) {
                _newState = Object.assign({}, formState);
                _updatedField = _newState[firstFieldKey];
                _updatedField.validator = function () {
                  return false;
                };
                updateFormState(_newState);
              }
            case 19:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4, null, [[5, 16]]);
    }));
    return function loadFirstField() {
      return _ref7.apply(this, arguments);
    };
  }();
  (0, _react.useEffect)(function () {
    makeDefaultCalls();
  }, [callFirstField]);
  return {
    formState: formState,
    getNextField: getNextField,
    getNextFieldKey: getNextFieldKey,
    updateFormState: updateFormState,
    callOnChange: callOnChange,
    fieldOnChange: fieldOnChange,
    submitIsDisabled: submitIsDisabled,
    onSubmit: onSubmit,
    submitUrl: submitUrl,
    client: client,
    setDefaultValues: setDefaultValues
  };
};
var _default = useApolloFetchUnlocker;
exports["default"] = _default;